import client from './client';

export const activityLogApi = {
  async getAll() {
    const { data } = await client.get('/activity-logs');
    return data.data ?? data;
  },
};
